export default __webpack_public_path__ + "dad4dee3f690d4ebe95754e2060d451d.png";